/**
 * React Query hook for programs scoped to the current app mode.
 */

import { useQuery } from '@tanstack/react-query';
import { useMode, type AppMode } from '@/contexts/ModeContext';
import { PROGRAM_CASCADE_PAGE_SIZE } from '@/constants/shared-catalog';
import { getProgramsForMode } from '@/utils/program-mode-utils';

/** `GET /academic/programs` — types from mode (`remote`+hybrid vs `in_person`+hybrid). */
export function useProgramsForMode(options?: {
  enabled?: boolean;
  mode?: AppMode;
  pageSize?: number;
  statuses?: string[];
}) {
  const { mode: contextMode } = useMode();
  const mode = options?.mode ?? contextMode;
  const pageSize = options?.pageSize ?? PROGRAM_CASCADE_PAGE_SIZE;
  const statuses = options?.statuses;

  return useQuery({
    queryKey: ['programs', 'mode', mode, pageSize, statuses],
    queryFn: () => getProgramsForMode(mode!, { pageSize, statuses }),
    enabled: mode !== null && (options?.enabled ?? true),
  });
}
